import { Typography } from "antd";
import { node, string } from "prop-types";

const { Title } = Typography;

export const MilestoneUsersContainer = ({ title, subTitle, children }) => (
  <>
    {title && <Title level={5}>{title}</Title>}
    <div className="pb-1">{subTitle}</div>
    {children}
  </>
);

MilestoneUsersContainer.propTypes = {
  title: string,
  subTitle: string.isRequired,
  children: node.isRequired,
};
